import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initVaultBridge } from "@/features/dreams/utils/vaultBridge";

if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const initPwaInstallPromptCapture = () => {
  if (typeof window === "undefined") return;
  if (window.__MD_PWA_INSTALL_PROMPT_CAPTURED__ === true) return;
  window.__MD_PWA_INSTALL_PROMPT_CAPTURED__ = true;

  window.addEventListener("beforeinstallprompt", (event) => {
    try {
      event.preventDefault();
    } catch (_) {
      /* ignore */
    }
    window.__MD_PWA_DEFERRED_PROMPT__ = event;
    window.dispatchEvent(new CustomEvent("morfeusz:pwa-install-ready"));
  });

  window.addEventListener("appinstalled", () => {
    window.__MD_PWA_DEFERRED_PROMPT__ = null;
    window.dispatchEvent(new CustomEvent("morfeusz:pwa-installed"));
  });
};

const registerPwaServiceWorker = () => {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  if (window.__MD_PWA_SW_REGISTERED__ === true) return;
  window.__MD_PWA_SW_REGISTERED__ = true;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((registration) => {
        try {
          registration?.update?.();
        } catch (_) {
          /* ignore */
        }
      })
      .catch(() => {
        /* PWA registration must not block the app. */
      });
  }, { once: true });
};

initPwaInstallPromptCapture();
initVaultBridge();
registerPwaServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
